import '../../../common-assets/styles/external/select2.min.css';
import '../../../common-assets/styles/external/flexslider.css';

import '../../../common-assets/styles/pages/details-page.scss';
import '../styles/auto-details-page.scss';

import '../../../common-assets/js/external/lazysizes.min.js';
import '../../../common-assets/js/external/jquery.flexslider-min';
import '../../../common-assets/js/components/common_ad_detail';
import '../../../common-assets/js/components/ad_contact_request';
import '../../../common-assets/js/components/image_slider';
import '../../../common-assets/js/components/ad_slider';
import '../../../common-assets/js/components/share_link_by_email';
import '../../../common-assets/js/components/ad_insurance';
import '../../../common-assets/js/components/compare_finance_options';
import '../../../common-assets/js/components/ad_recommendation';
import '../../../common-assets/js/components/ad_slider_datalayer';
import '../../../common-assets/js/ad_status_change';

const energyGrade = {
    expandGradeSection() {
        let $expandGradeSection = $('.expandGradeSection');
        let gradeNumber = $expandGradeSection.data('grade-number') || '';
        let co2Emission = $expandGradeSection.data('co2-emission') || '';
        let appendElement = `<div id="appendGrade">${co2Emission}</div>`;
        $('.co2-information__bars-block div[class^="co2-information__bars-row_"]').each(function() {
            $(this).removeClass('active-bar');
            // Remove old appendGrade element
            if ($(this).children('#appendGrade').length > 0) {
                $(this).children('#appendGrade').remove();
            }

            if ($(this).attr('class').match(`co2-information__bars-row_${gradeNumber}`)) {
                $(this).addClass('active-bar').append(appendElement);
            }
        });

        let $co2Information = $('.co2Information');
        $co2Information.toggle();
        if ($co2Information.is(':visible')) {
            $('#energyGradeMainSection').addClass('co2-information__open');
        } else {
            $('#energyGradeMainSection').removeClass('co2-information__open');
        }
    },
};

const dealerOtherAds = {
    showDealerOtherAdsSection() {
        let $showDealerOtherAds = $('#dealerOtherAds, #dealerOtherAdsMobile');

        if ($showDealerOtherAds.length) {
            let dealerUuid = $showDealerOtherAds.data('user-uuid') || '';
            let dealerSiteUrl = $showDealerOtherAds.data('dealer-site-url') || '';
            let adId = $('#adDetailPage').data('ad-id') || '';
            let params = `dealerUuid=${dealerUuid}&dealerSiteUrl=${encodeURIComponent(dealerSiteUrl)}&adId=${adId}`;

            $.get(Routing.generate('dealership_other_ads'), params, function(response) {
                if (response?.dealership_other_ads_html) {
                    $showDealerOtherAds.html(response.dealership_other_ads_html).show();
                }
            });
        }
    },
};

const conditionReport = {
    showLoader() {
        $('.global-loader-img-big').show();
    },
    hideLoader() {
        $('.global-loader-img-big').hide();
    },
    showConditionReport(adId, conditionReportName) {
        const params = {
            adId,
            conditionReportName,
        };

        this.showLoader();
        $.get(Routing.generate('show_condition_report'), params, function(response) {
            if (response.success && response?.conditionReportContent) {
                const byteArrayResponse = commonUtils.base64ToUint8Array(response.conditionReportContent);

                // Create a Blob object for the PDF content
                const pdfBlob = new Blob([byteArrayResponse], { type: 'application/pdf' });

                // Create a URL for the Blob
                const pdfUrl = URL.createObjectURL(pdfBlob);

                if (commonUtils.isAppleDevice()) {
                    globalThis.location.href = pdfUrl; // Opens in the current tab for Apple devices
                } else {
                    globalThis.open(pdfUrl, '_blank'); // Opens in a new tab for other devices
                }

                conditionReport.hideLoader();
            } else {
                conditionReport.hideLoader();
            }
        });
    },
};

$(function() {
    let $body = $('body');

    // Show energy grade section
    $body.on('click', '.expandGradeSection', function() {
        energyGrade.expandGradeSection();
    });

    // Display selected option in custom select box
    $body.on('click', '.customSelectOption', function() {
        let selectedOption = $(this).text();
        $('.customSelectOption').removeClass('dropdown-active-link');
        $(this).addClass('dropdown-active-link');
        $('.customSelect').text(selectedOption);
    });

    // Show condition report fetched from s3 bucket
    $body.on('click', '.openConditionReport', function() {
        const $this = $(this);
        const adId = $this.attr('data-ad-id');
        const conditionReportName = $this.attr('data-condition-report');

        if (adId && conditionReportName) {
            conditionReport.showConditionReport(adId, conditionReportName);
        }
    });

    // Add dealership button click event
    $body.on('click', '#dealershipButton', function() {
        const salesforceId = $(this).data('salesforce-id');

        $.ajax({
            url: Routing.generate('generate_search_hash'),
            type: 'POST',
            data: { salesforceParentId: salesforceId },
            timeout: 10000, // 10 second timeout
            success(response) {
                const url = response?.searchHash
                    ? Routing.generate('advance_search_list', { haku: response.searchHash })
                    : globalThis.location.origin;

                if (commonUtils.isAppleDevice()) {
                    globalThis.location.href = url; // Opens in the current tab for Apple devices due to pop up block security
                } else {
                    globalThis.open(url, '_blank'); // Opens in a new tab for other devices
                }
            },
        });
    });

    dealerOtherAds.showDealerOtherAdsSection();
});
